import { render, staticRenderFns } from "./productOneForm.vue?vue&type=template&id=c5e88e00"
import script from "./productOneForm.vue?vue&type=script&lang=js"
export * from "./productOneForm.vue?vue&type=script&lang=js"
import style0 from "./productOneForm.vue?vue&type=style&index=0&id=c5e88e00&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports